import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../ThemeContext';

const Footer = () => {
  const { isInstitutional } = useTheme();

  const headingColor = isInstitutional ? '#C4532D' : '#00FF41';
  const headingFont = isInstitutional ? "'Titillium Web', sans-serif" : 'monospace';

  return (
    <footer data-testid="footer" className={`py-16 pb-24 border-t ${isInstitutional ? 'border-[#E2DED6]' : 'border-white/10'}`}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <span className="text-[#00FF41] font-mono font-black text-2xl">&lt;/</span>
            <p className="font-mono font-black text-lg mt-2 mb-4" style={{ color: '#00FF41' }}>&lt;/AI_covo.tech&gt;<sup style={{ fontSize: '0.5em', verticalAlign: 'super' }}>&reg;</sup></p>
            <p className="font-bold mb-2 font-mono" style={{ color: '#00FF41' }}>&lt;/ DIGITAL HUB SOCIALE</p>
            <p className={`text-sm ${isInstitutional ? 'text-[#5A6B80]' : 'text-zinc-500'}`}>
              Colle di Val d'Elsa (SI)<br />
              Città dal 1592
            </p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-wider mb-4" style={{ color: headingColor, fontFamily: headingFont, fontWeight: 700 }}>Servizi</h4>
            <ul className={`space-y-2 text-sm ${isInstitutional ? 'text-[#5A6B80]' : 'text-zinc-400'}`}>
              <li><Link to="/sede" className={`transition-colors ${isInstitutional ? 'hover:text-[#1B2A4A]' : 'hover:text-white'}`}>Doposcuola</Link></li>
              <li><Link to="/formazione" className={`transition-colors ${isInstitutional ? 'hover:text-[#1B2A4A]' : 'hover:text-white'}`}>Formazione Digitale</Link></li>
              <li><Link to="/sede" className={`transition-colors ${isInstitutional ? 'hover:text-[#1B2A4A]' : 'hover:text-white'}`}>Spazi Sociali</Link></li>
              <li><Link to="/hub" className={`transition-colors ${isInstitutional ? 'hover:text-[#1B2A4A]' : 'hover:text-white'}`}>Chi Siamo</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-wider mb-4" style={{ color: headingColor, fontFamily: headingFont, fontWeight: 700 }}>Risorse</h4>
            <ul className={`space-y-2 text-sm ${isInstitutional ? 'text-[#5A6B80]' : 'text-zinc-400'}`}>
              <li><Link to="/brand" className={`transition-colors ${isInstitutional ? 'hover:text-[#1B2A4A]' : 'hover:text-white'}`}>Brand Kit</Link></li>
              <li><Link to="/dona" className={`transition-colors ${isInstitutional ? 'hover:text-[#1B2A4A]' : 'hover:text-white'}`}>Sostienici</Link></li>
              <li><Link to="/links" className={`transition-colors ${isInstitutional ? 'hover:text-[#1B2A4A]' : 'hover:text-white'}`}>RoadMap</Link></li>
              <li><Link to="/contatti" className={`transition-colors ${isInstitutional ? 'hover:text-[#1B2A4A]' : 'hover:text-white'}`}>Contatti</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-wider mb-4" style={{ color: headingColor, fontFamily: headingFont, fontWeight: 700 }}>Contatti</h4>
            <ul className={`space-y-2 text-sm ${isInstitutional ? 'text-[#5A6B80]' : 'text-zinc-400'}`}>
              <li>info@aicovo.it</li>
              <li>Colle di Val d'Elsa (SI)</li>
              <li>Toscana, Italia</li>
              <li>
                <a href="https://wa.me/393273839782" target="_blank" rel="noopener noreferrer" className={`transition-colors ${isInstitutional ? 'hover:text-[#C4532D]' : 'hover:text-[#00FF41]'}`} data-testid="footer-whatsapp">
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className={`py-8 border-t mb-8 ${isInstitutional ? 'border-[#E2DED6]' : 'border-white/10'}`}>
          <p className="text-center text-xs uppercase tracking-widest mb-1"
            style={{ color: isInstitutional ? '#5A6B80' : '#71717a', fontFamily: headingFont }}>
            Sponsored By
          </p>
          <div className="flex justify-center items-center gap-10 md:gap-16 flex-wrap">
            <a href="https://www.schedabusiness.com" target="_blank" rel="noopener noreferrer" data-testid="footer-sponsor-sbp" className="opacity-90 hover:opacity-100 transition-opacity flex flex-col items-center gap-1">
              <p className="font-black italic" style={{ fontSize: '18px', color: '#D4A843', fontFamily: "'Poppins', 'Arial Black', sans-serif", lineHeight: 1.1, letterSpacing: '-0.3px' }}>schedabusiness.com</p>
              <p className="mt-1">
                <span className="wave-text" style={{ fontFamily: "'Georgia', serif", fontWeight: 700, fontStyle: 'italic', fontSize: '10px' }}>
                  {'se non ti trovano, non esisti'.split('').map((char, i) => (
                    <span key={i} style={{ color: '#fff' }}>{char === ' ' ? '\u00A0' : char}</span>
                  ))}
                </span>
              </p>
            </a>
            <a href="https://www.governo.it/it/la-presidenza-del-consiglio-dei-ministri" target="_blank" rel="noopener noreferrer" data-testid="stemma-governo" className="opacity-60 hover:opacity-100 transition-opacity">
              <img src="/stemma_governo.png" alt="Governo Italiano" className="h-16 md:h-20 w-auto" />
            </a>
            <a href="https://www.regione.toscana.it/" target="_blank" rel="noopener noreferrer" data-testid="stemma-toscana" className="opacity-60 hover:opacity-100 transition-opacity">
              <img src="/stemma_toscana.png" alt="Regione Toscana" className="h-16 md:h-20 w-auto" />
            </a>
          </div>
        </div>

        <div className={`pt-8 border-t flex flex-col md:flex-row justify-between items-center gap-4 ${isInstitutional ? 'border-[#E2DED6]' : 'border-white/10'}`}>
          <p className="text-xs font-mono" style={{ color: isInstitutional ? '#5A6B80' : '#52525b' }}>
            &copy; 2030 <span className="text-[#00FF41] font-black">&lt;/</span>AI_COVO · <span style={{ color: headingColor }}>DIGITAL HUB SOCIALE</span>
          </p>
          <p className="text-xs font-mono" style={{ color: isInstitutional ? '#5A6B80' : '#52525b' }}>
            &lt;/BUILT_FOR_COMMUNITY/&gt;
          </p>
          <p className="text-zinc-700 text-[9px] font-mono">Merchandising &lt;/ riservato ai soci tesserati</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
